export const VAT_NUMBER_VALIDATION_STATUS = {
  VALID: 'valid',
  NOT_VALID: 'notValid',
  COULD_NOT_VALIDATE: 'couldNotValidate',
  SKIPPED: 'skipped',
} as const;

export const ADDRESS_VALIDATION_STATUS = {
  MATCHING: 'matching',
  FIELD_MISMATCH: 'fieldMismatch',
  REGISTRY_ADDRESS_MISSING: 'registryAddressMissing',
} as const;

export type AddressValidationStatus = ValueOf<typeof ADDRESS_VALIDATION_STATUS>;

export const B2B_FALLBACK_TAX_RATE = 23;

export type VatNumberValidationStatus = ValueOf<typeof VAT_NUMBER_VALIDATION_STATUS>;
export type VatNumberValidationFailure = Exclude<
  VatNumberValidationStatus, 
  typeof VAT_NUMBER_VALIDATION_STATUS.VALID | typeof VAT_NUMBER_VALIDATION_STATUS.SKIPPED
>;
export type VatValidationError = '' | VatNumberValidationFailure;
